import { render, staticRenderFns } from "./MessagePremium.vue?vue&type=template&id=96eb3a28&scoped=true&"
import script from "./MessagePremium.vue?vue&type=script&lang=js&"
export * from "./MessagePremium.vue?vue&type=script&lang=js&"
import style0 from "./MessagePremium.vue?vue&type=style&index=0&id=96eb3a28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96eb3a28",
  null
  
)

export default component.exports